<section class="product-footer">
    @if (productReference) {
    <p class="product-sku paragraph-small">
        @if (isComposite) {

        <ng-container i18n="@@hermes-commerce-product-sku.product-references"> Product references: </ng-container>
        <br />

        } @else {

        <ng-container i18n="@@hermes-commerce-product-sku.product-reference"> Product reference: </ng-container>&nbsp; }

        <span class="product-sku-display-sku">{{ productReference }}</span>
    </p>
    } @if (shouldDisplayAgecRedirectionForSimpleProduct) {
    <p class="product-sku paragraph-small">
        <span class="product-agec-text" i18n="@@hermes.agec.text.product.link" aria-hidden="true"
            >Pour consulter les caractéristiques environnementales de ce produit,</span
        >
        <span
            id="link-to-agec"
            name="link-to-agec"
            class="link-to-agec"
            tabindex="0"
            role="link"
            i18n-aria-label="@@hermes.agec.aria.label"
            i18n="@@hermes.agec.text.click_here"
            aria-label="Cliquez ici pour consulter les caractéristiques environnementales"
            (click)="openTabAgecPage()"
            >cliquez ici</span
        >
    </p>
    } @if (isComposite) {
    <div class="product-sku">
        @for (product of agecLinks; track product; let i = $index) {
        <div>
            @if (product.isAgec) {
            <p class="product-info paragraph-small">
                <span
                    class="product-agec-text"
                    [attr.data-testid]="'product-info-' + i"
                    i18n="@@hermes.agec.text.double_product.link"
                    aria-hidden="true"
                    >Pour consulter les caractéristiques environnementales du produit
                    {{ product.objectTypeTitle }}</span
                >

                <span
                    id="link-to-agec"
                    name="link-to-agec"
                    class="link-to-agec"
                    tabindex="0"
                    role="link"
                    i18n-aria-label="@@hermes.agec.aria.label"
                    i18n="@@hermes.agec.text.click_here"
                    aria-label="Cliquez ici pour consulter les caractéristiques environnementales"
                    (click)="openTabAgecPage(product.sku)"
                    >cliquez ici</span
                >.</p
            >
            }
        </div>
        }
    </div>
    }

    <p class="contact-us paragraph-small">
        <span class="contact-us-first-trad" i18n="@@hermes-commerce-product-sku.like-to-know-more">
            Like to know more?
        </span>
        <button
            (click)="onCustomerServiceLinkClicked($event)"
            class="contact-link"
            i18n="@@hermes-commerce-product-sku.contact-us">
            Contact Customer Service
        </button>
    </p>
</section>
